module.exports = __webpack_public_path__ + "static/wjazd-zima-52b10f7702487aab3cb3d51874f72a25.jpg";